import { IFormSchema } from "../types/types";

export const getFieldsRequired = (
  pages: IFormSchema[][],
  values: any,
  step: number
) => {
  const activePage: IFormSchema[] = pages[step];

  const isRequired = activePage
    .filter((item: IFormSchema) => item.component.type !== "file")
    .map((item: IFormSchema) => {
      if (item.required) {
        return values[item.id]?.length > 0 ? true : false;
      }
    })
    .some((result) => result === false);

  return {
    isRequired,
  };
};
